(() => {
  function enhance(root) {
    if (root.dataset.seoReady) return;
    root.dataset.seoReady = 'true';
    const copy = root.querySelector('[data-seo-copy]');
    if (!copy) return;
    copy.querySelectorAll('style,script,[id="readMoreBtn"],[id="readLessBtn"],.amaara_moreless-button').forEach(node => node.remove());
    copy.querySelectorAll('[id="inlineContent"],[id="moreContent"]').forEach(node => {node.style.removeProperty('display');});
    const popular = copy.querySelector('.popular-searches');
    if (popular) {
      const links = [...popular.querySelectorAll('a[href]')];
      const list = document.createElement('ul');
      links.forEach(link => {
        link.textContent = link.textContent.replace(/\s+/g,' ').trim();
        const item = document.createElement('li');
        item.append(link);
        list.append(item);
      });
      popular.querySelectorAll('ul,ol').forEach(node => node.remove());
      if (links.length) popular.append(list);
      popular.remove();
    }
    const body = copy.querySelector('.page-content') || copy;
    const heading = body.querySelector('h1,h2');
    const paragraph = body.querySelector('p');
    if (paragraph && body.textContent.trim().length > paragraph.textContent.trim().length + (heading?.textContent.trim().length || 0) + 100) {
      const intro = document.createElement('div');
      intro.className = 'o2o-collection-seo__intro';
      if (heading) intro.append(heading);
      intro.append(paragraph);
      const details = document.createElement('details');
      details.className = 'o2o-collection-seo__details';
      const summary = document.createElement('summary');
      summary.textContent = root.dataset.moreLabel;
      const article = document.createElement('div');
      article.dataset.seoBody = '';
      while (body.firstChild) article.append(body.firstChild);
      details.append(summary,article);
      copy.replaceChildren(intro,details);
    }
    if (popular) copy.append(popular);
  }
  const init = (scope = document) => scope.querySelectorAll('[data-collection-seo]').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init());
  else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
